var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{attrs:{"align-v":"end"}},_vm._l((_vm.data),function(ref){
var name = ref[0];
var value = ref[1];
var i = ref[2];
return _c('div',{key:i},[_c('b-col',[_c('AutoField',{attrs:{"label":name.toString(),"value":value.toString(),"readonly":true}})],1)],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }